import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=385e5f7c&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetails.vue?vue&type=style&index=0&id=385e5f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385e5f7c",
  null
  
)

export default component.exports